import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { map } from 'lodash';
import { Paper, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import KTitle from '../../components/KJRN/KTitle';

const columnStyle = {
  whiteSpace: 'normal',
  paddingRight: 12,
};

const PurchasesTable = ({
  entries, table, showTitle,
}) => {
  const { loading } = useSelector(state => state.teriaReducer);

  return (
    <React.Fragment>
      {showTitle ? <KTitle
        containerStyle={{ marginBottom: 0, marginTop: 12 }}
        style={{
          fontSize: 18,
          fontWeight: 'normal',
          marginBottom: 0,
          marginLeft: 12,
        }}
        subtitleStyle={{ marginLeft: 0 }}
        title={table.title}
      /> : ''}
      <Paper style={{ margin: 12 }}>
        <Table
          bodyStyle={{ overflowX: 'none', overflowY: 'none' }}
          fixedHeader
        >
          <TableHeader
            displaySelectAll={false}
            adjustForCheckbox={false}
            enableSelectAll={false}
          >
            <TableRow key="table-key">
              {map(table.columns, (c, i) => (
                <TableHeaderColumn key={i} style={{ ...columnStyle, width: c.width || 100 }}>
                  <FormattedMessage id={c.title} />
                </TableHeaderColumn>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody
            displayRowCheckbox={false}
            deselectOnClickaway={false}
            showRowHover={false}
            stripedRows={false}
          >
            {!loading ? map(entries, (data, index) => (
              <TableRow key={index}>(
                {map(table.columns, (c, i) => (
                  <TableRowColumn key={i} style={{ ...columnStyle, width: c.width || 100 }}>
                    {c.render ? c.render(data[c.dataIndex]) : data[c.dataIndex]}
                  </TableRowColumn>
                ))})
              </TableRow>
            )) : null}
          </TableBody>
        </Table>
      </Paper>
    </React.Fragment>
  );
};

PurchasesTable.propTypes = {
  table: PropTypes.shape({
    title: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  entries: PropTypes.array.isRequired,
  showTitle: PropTypes.bool.isRequired,
};

export default connect()(PurchasesTable);



// WEBPACK FOOTER //
// ./src/sites/teria/PurchasesTable.js